export default __webpack_public_path__ + "static/18-71102ff0291866fa66450379ac2324fe.png";